import video from "../../../assets/images/app_night.mp4";

export default function Section6() {
  return (
    <section className="relative z-10 w-full flex flex-col items-center justify-center mb-[80px] md:mb-[130px] lg:mb-[150px]">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-center mb-16">
          <h2 className="text-[48px] font-normal text-white tracking-tight mb-4 text-center">
            How value flows through the Switch Protocol
          </h2>
          <h3 className="text-[18px] text-white mb-[70ox] tracking-tight text-center">
            Experience a unified interface where payments, liquidity routing,
            and settlement flow effortlessly Manage, track, and interact with
            value — all in one seamless dashboard
          </h3>
        </div>
        <div className="flex flex-col gap-4">
          <video
            src={video}
            autoPlay
            muted
            loop
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}
